import React,{useRef, useState} from 'react';
import styles from "./product-file-attachment.scss";
import {connect} from "react-redux";
import FileSelector from "../../common/FileSelector";
import {uploadMultipleFile} from "../../common/fileUtills";
import {setFileAttachmentData, toggleViewFileDetailsSlider, toggleFileProgressBar, cancelPendingFiles, markPreviouslyUploadedFiles} from "../../actions/products";
import ViewUploadedFilesSlider from './ViewUploadedFiles/ViewUploadedFilesSlider';
import ViewFileDetailsSlider from './ViewUploadedFiles/ViewFileDetailsSlider';
import withRipple from 'jd-library/withRipple';
import {fileManager} from '../add-edit-item/appUtils/AppUtils';
import toastMessageActions from 'jd-library/toastMessageActions';

const ProductFileAttachment = (props) => {
	const fileSelector = useRef(null);
	const [showViewFilesSlider, toggleViewFilesSlider] = useState(false);
    const prevScrollTop = useRef(null);
	const fileAttachmentArr = props.fileAttachmentArr;
	const fileKeyRef = useRef(null);
	const validFiles = fileAttachmentArr.filter(cur => {
		return ((cur.uploading || cur.uploaded) && !cur.isDeleted)
	});
	const totalFiles = validFiles.length
	let subText = "";
	if(totalFiles){
		if(totalFiles == 1){
			subText = validFiles[0].fileName;
		}else{
			subText = validFiles.length + " Files"
		}
	}

	const getFileExtension = fileName => fileName.split('.').pop();

	const onFileUploadByAppCB = (value) => {
		console.log(value);
		if(value.event == 'uploadStarted'){
			console.log(value.event);
			markPreviouslyUploadedFiles();
			let fileData = {
				fileName: value.filename,
				uploading: true,
				uploaded: false,
				ext: getFileExtension(value.filename),
				fileKey: +new Date()
		   };
		   fileKeyRef.current = fileData.fileKey;
		   console.log(fileData);
		   fileUploadCB(fileData);
		}else if(value.event == 'uploadProgress'){
			console.log(value.event);
		}
		if(value.success){
			let data = JSON.parse(value.data);
			let fileData = {
				fileName: value.filename,
				uploading: false,
				uploaded: true,
				isFileLimitError: validFiles.length >= 5,
				ext: getFileExtension(value.filename),
				fileKey: fileKeyRef.current,
				id: atob(data[0].id)
		   };
		   
		   console.log(fileData);
		   fileUploadCB(fileData);
			// let item = {
            //     "name": value.filename,
            //     //"id": id
            // };
            //let uploadId = atob(data[0].id);
            //files.push({"file":item,"uploaded":false,"id":id,"uploadId":uploadId});
		}
	}

	const handleClick = (e) => {
		if(!totalFiles){
			if(window.jdInterface && !window.jdInterface.openNativeFileChooser){
				const outletDetails = {
					results: {
						storeid: props.storeId
					}
				}
			  fileManager({outletDetails, supid: props.supplierId, callback: onFileUploadByAppCB});
			}else{
                fileSelector.current.triggerClick(true);  
			}
		}else{
			openCloseViewFilesSlider(true);
			props.toggleFileProgressBar({show: false});
		}
	}

	const openCloseViewFilesSlider = (flag) => {
		if(flag){
			prevScrollTop.current = window.scrollY;
			toggleViewFilesSlider(flag);
		}else{
			toggleViewFilesSlider(flag);
			setTimeout(() => {
				if(prevScrollTop.current) {
					window.scrollTo(0, prevScrollTop.current);
				}
				prevScrollTop.current = null;
			});
		}
	}

	const uploadFiles = (e) => {
		if(window.jdInterface && !window.jdInterface.openNativeFileChooser){
			const outletDetails = {
				results: {
					storeid: props.storeId
				}
			}
		  fileManager({outletDetails, supid: props.supplierId, callback: onFileUploadByAppCB});
		}else{
			fileSelector.current.triggerClick(true);
		}	
	}

	const closeViewFilesSlider = () => {
		openCloseViewFilesSlider(false);
		props.cancelPendingFiles({productId: props.productId})
	}

	const closeViewFileDetailsSlider = () => {
        props.toggleViewFileDetailsSlider({show: false});
	}
	const validMimeType = [
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',//docs
		'application/msword', //doc
		'application/vnd.ms-excel',//xls,
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',//xlsx
		'application/vnd.ms-powerpoint',//ppt pps
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',//pptx
		'application/vnd.openxmlformats-officedocument.presentationml.slideshow',//ppsx
		'application/vnd.oasis.opendocument.text',//odt
		'application/pdf','image/png', 'image/jpeg', 'image/jpg', 'image/webp']
	
	const validExtensions = [
		".docx",".doc",".xls",".xlsx",".ppt",".pptx",".pps",".ppsx",".odt",".pdf",".png",".jpg",".webp"
	]

	const markPreviouslyUploadedFiles = () => {
	    if(props.fileAttachmentArr.length > 0){
			props.cancelPendingFiles({productId: props.productId});	
           props.markPreviouslyUploadedFiles({productId: props.productId});
		}
	}
	
	const onChange = (e) => {
		markPreviouslyUploadedFiles();
		const offset = validFiles.length;
		uploadMultipleFile({
			isJdVendor: props.isJdVendor,
			fileLimit : 5 - offset,
			maxFileSize : 25 * 1024 * 1024,
			data:e.target.files,
			validMimeType,
			validExtensions,
			supplierId:props.supplierId,
			cb:function(fileData){
				if(fileData?.isError && fileData?.msg) {
					props.showToastMessage({
						message: fileData.msg,
						type: "error",
					  });
				}
				// if(!fileData?.uploading) {
				// 	fileData.uploaded  = true;
				// }
				fileUploadCB(fileData);			   
				// const ext = fileData.ext;
				// const data = {
				// 	uploaded : fileData.uploaded,
				// 	uploading : fileData.uploading,
				// 	fileName : fileData.fileName.replace(new RegExp("\."+ext+"$"),''),
				// 	ext,
				// 	id : fileData.id,
				// 	isFileLimitError: fileData.isFileLimitError,
				// 	isFileSizeError:fileData.isFileSizeError,
				// 	fileKey : fileData.fileKey
				// };
				// props.setFileAttachmentData({
				// 	productId:props.productId,
				// 	data,
				// });
				// openCloseViewFilesSlider(true);
				// props.toggleFileProgressBar({show: true});
			}
		})
	}

	const fileUploadCB = (fileData) => {
			const ext = fileData.ext;
			const data = {
				uploaded : fileData.uploaded,
				uploading : fileData.uploading,
				fileName : fileData.fileName.replace(new RegExp("\."+ext+"$"),''),
				ext,
				id : fileData.id,
				isFileLimitError: fileData.isFileLimitError,
				isFileSizeError:fileData.isFileSizeError,
				fileKey : fileData.fileKey
			};
			props.setFileAttachmentData({
				productId:props.productId,
				data
			});
			if(fileData?.isError) {
				openCloseViewFilesSlider(true);
				props.toggleFileProgressBar({show: false});
			} else {
				openCloseViewFilesSlider(true);
				props.toggleFileProgressBar({show: true});
			}			
	}

	const AttachFile = withRipple(props => {
           return(
			 <div 
				className={`list-box ${props.isJdVendor ? 'jd-vendor' : ''} ${styles['prod-file-attachment']} ${props.rippleClass} ${props.isReadOnly ? 'readonly-attach' : ''}`}
				onClick={props.onClick}
				{...props.rippleHandler}
			 >
					<div className={styles['attach-files-container']}>
						<div className={styles['title']}>
						<div>Attach Files</div>
						{subText ? <div className={styles['sub-text']}>{subText}</div> : null}
						</div>
					</div>
					<i className="icon-Next"></i>
					{props.renderRipple()}
			</div>   
		 )
	});

	const progressProps = {
		uploadedCount:0,
		uploadPercentage:0,
		errorCount:0,
		allUploaded:false,
		previouslyUploadedCount:0,
		deletedCount:0,
		allDeleted:false
	}
	fileAttachmentArr.forEach((item) => {
		if(item.isDeleted){
			progressProps.deletedCount += 1;   
		}
		if(!item.isPreviouslyUploaded){
            if(item.uploaded){
				progressProps.uploadedCount += 1;
				progressProps.uploadPercentage += 20;
			}else{
				if(item.isFileLimitError || item.uploaded === undefined){
					progressProps.errorCount += 1;
					progressProps.uploadPercentage += 20;
				}else if(!item.uploaded && item.uploading === undefined){
					progressProps.errorCount += 1;
				}
			}
		}else{
		   progressProps.previouslyUploadedCount += 1;
		}
   	});
    if( (progressProps.uploadedCount + progressProps.errorCount) == fileAttachmentArr.length - progressProps.previouslyUploadedCount){
        progressProps.allUploaded = true;
        progressProps.uploadPercentage = 100;
	}
	if((progressProps.deletedCount + progressProps.errorCount) == fileAttachmentArr.length){
		progressProps.allDeleted = true;
	}

	const accept = [
		...validMimeType,
		...validExtensions
	]
	return (
		<>
			{(!totalFiles && props.isReadOnly) ? null : <AttachFile
				{...props}
				onClick={handleClick}
			/>}
			{ props.isReadOnly ? null : <FileSelector 
				accept={accept.join()}
				onChange={onChange} 
				ref={fileSelector} 
			/>}
			{showViewFilesSlider &&
				<ViewUploadedFilesSlider
					closeSlider = {closeViewFilesSlider}
					productId = {props.productId}
					uploadFiles={uploadFiles}
					hideAddButton={!progressProps.allUploaded  || (validFiles.length >= 5 || !totalFiles)}
					progressProps = {progressProps}
					isJdVendor = {props.isJdVendor}
				/> 
			}
			{
				props.showViewDetailsSlider &&
				<ViewFileDetailsSlider
					productId = {props.productId}
					closeSlider = {closeViewFileDetailsSlider}
					progressProps={progressProps}
				/>
			}
		</>
	)
}

const mapStateToProps = (state,props) => {
	return {
		...props,
		fileAttachmentArr : state.products.allProducts[props.productId] && state.products.allProducts[props.productId].fileAttachmentArr || [],
		supplierId : state.session.supplierId,
		showViewDetailsSlider: state.products.fileAttachmentData.showViewDetailsSlider,
		allUploaded: state.products.fileAttachmentData.allUploaded,
		permissionData: state.products.fileAttachmentData.permissionData,
		storeId: state.permissions.storeId
	}
}

export default connect(mapStateToProps,{setFileAttachmentData, toggleViewFileDetailsSlider, toggleFileProgressBar, cancelPendingFiles, markPreviouslyUploadedFiles, showToastMessage: toastMessageActions.showMessage})(ProductFileAttachment);